import React, { useRef } from 'react';
import { UploadImgContainer, UserImg } from './MiniProfile.style';
import changeIcon from '../../../assets/icons/gallery-edit.svg';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';

type MiniProfileType = {
	width?: number;
	outlineColor?: string;
	offset?: number;
	nameSize?: number;
	emailSize?: number;
	margin?: string;
	name?: string;
	email?: string;
	img?: any;
	changeimge?: any;
	loading?: boolean;
	leftPadding?: boolean;
	reset?: any;
	aRef?: any;
	preview?: boolean;
  longEmail?:string
};

const MiniProfile = ({
	width = 48,
	outlineColor = '#01ABC1',
	leftPadding = false,
	offset = 2,
	nameSize = 16,
	emailSize = 16,
	margin = '0',
	name,
	email,
	img,
	changeimge,
	loading = false,
	reset,
	aRef,
	preview,
  longEmail
}: MiniProfileType) => {
	return (
		<UserImg width={width} outlineColor={outlineColor} offset={offset} nameSize={nameSize} emailSize={emailSize} margin={margin}>
			<figure className="profileAvatar">
				{loading ? (
					<div className="mt-3 flex items-center justify-center">
						<ProgressSpinner />
					</div>
				) : (
					<img src={img} alt="" />
				)}
			</figure>
			{changeimge && (
				<>
					<UploadImgContainer>
						<img className="changeIcon" src={changeIcon} alt="icon" />
						<input className="fileInput" type="file" ref={aRef} onChange={(e) => changeimge(e)} />
					</UploadImgContainer>
				</>
			)}

			{(name || email) && (
				<div className="userInfo">
					<p className="regularText name">{name}</p>
					{preview && <Tooltip target=".email" showDelay={500} />}

					<p data-pr-tooltip={longEmail} data-pr-position="top" className="smallMainText email ">
						{email}
					</p>
				</div>
			)}
		</UserImg>
	);
};

export default MiniProfile;
